module.exports = __webpack_public_path__ + "static/homer1004-63a6a2c3026b94cb4a24bacc521a93a5.jpg";